import { PostcodeManagerService } from './postcode-manager.service';
import { ServiceTypes } from './globals.service';
import { Clients } from '../services/globals.service';
import * as i0 from "@angular/core";
import * as i1 from "./postcode-manager.service";
import * as i2 from "./globals.service";
export class PricingService {
    constructor(_postcodeManager, _clients) {
        this.ServiceTypes = ServiceTypes;
        this.postcodeManager = null;
        this.clients = null;
        this.postcodeManager = _postcodeManager;
        this.clients = _clients;
    }
}
PricingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PricingService_Factory() { return new PricingService(i0.ɵɵinject(i1.PostcodeManagerService), i0.ɵɵinject(i2.Clients)); }, token: PricingService, providedIn: "root" });
export class TradeTypePricing {
    constructor() {
        this.id = 0;
        this.jobTypes = [];
        this.hourlyRate = 0;
        this.calloutFee = 0;
        // out of hours
        this.oohHourlyRate = 0;
        this.oohCalloutFee = 0;
    }
}
export class JobTypePricing {
    constructor() {
        this.id = 0;
        this.triageQuestions = [];
        this.partsCostBase = 0;
        this.partsCostPremium = 0;
        this.attendanceHours = 1;
        this.additionalCalloutFee = 0;
    }
}
export class TriageQuestionPricing {
    constructor() {
        this.additionalFixedCost = 0;
        this.additionalPerCost = 0;
        this.modifiedBasePartsCost = 0;
        this.modifiedPremiumPartsCost = 0;
        this.hourlyMultiplier = 0;
        this.partsMultiplier = 0;
        this.partsAdd = 0;
    }
}
